var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({staticClass:"app-link",class:_vm.type,attrs:{"data-jest":"app-link","target":"_blank"}},'a',_vm.$attrs,false),[_vm._t("default"),(_vm.text)?_c('span',{staticClass:"app-link__title"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }